"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.poisLayerId = void 0;
exports.usePois = usePois;
var _maplibreGl = require("maplibre-gl");
var _react = _interopRequireWildcard(require("react"));
var _client = require("react-dom/client");
var _reactI18next = require("react-i18next");
var _poiPopup = _interopRequireDefault(require("../../components/map/poi-popup"));
var _utils = require("../../utils");
var _layers = require("./layers");
var _popup = require("./popup");
var _routing = require("./routing");
var _source2 = require("./source");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const sourceId = 'pois';
const poisLayerId = exports.poisLayerId = 'pois';
const _minZoom = 13;
const _categoryMinZoom = {};
const _asMarkerMinZoom = 14;
const _categoryAsMarkerMinZoom = {};
function usePois(map, theme, smallDevice, _categories, _selectedCategories, _poiAnnotationsMap = {}, options = {}) {
  const [selectedPoi, selectPoi] = (0, _react.useState)(null);
  const hoveredPoi = (0, _react.useRef)(null);
  const initialized = (0, _react.useRef)(false);
  const categories = (0, _react.useRef)(_categories);
  const selectedCategories = (0, _react.useRef)(_selectedCategories);
  const poiAnnotationsMap = (0, _react.useRef)(_poiAnnotationsMap);
  const displayOnlyBicycleHome = (0, _react.useRef)(options.displayOnlyBicycleHome || false);
  const markers = (0, _react.useRef)({});
  const poiTooltip = (0, _react.useRef)(null);
  const poisRef = (0, _react.useRef)([]);
  const poiPopupRef = (0, _react.useRef)(null);
  const selectedPoiIdRef = (0, _react.useRef)(null);
  const selectedTripStep = (0, _react.useRef)(options.selectedTripStep);
  const snackbarKey = (0, _react.useRef)(null);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    getGeoJSONSource,
    addGeoJSONSource,
    updateGeoJSONSource,
    clearGeoJSONSource
  } = (0, _source2.useSource)(map, sourceId);
  const {
    addCircleLayer
  } = (0, _layers.useLayers)(map);
  const {
    centerPopup
  } = (0, _popup.usePopup)(map);
  const minZoom = options.minZoom || _minZoom;
  const categoryMinZoom = {
    ..._categoryMinZoom,
    ...(options.categoryMinZoom || {})
  };
  const asMarkerMinZoom = options.asMarkerMinZoom || _asMarkerMinZoom;
  const categoryAsMarkerMinZoom = {
    ..._categoryAsMarkerMinZoom,
    ...(options.categoryAsMarkerMinZoom || {})
  };
  (0, _react.useEffect)(() => {
    categories.current = _categories;
  }, [_categories]);
  (0, _react.useEffect)(() => {
    selectedCategories.current = _selectedCategories;
  }, [_selectedCategories]);
  (0, _react.useEffect)(() => {
    poiAnnotationsMap.current = _poiAnnotationsMap;
  }, [_poiAnnotationsMap]);
  (0, _react.useEffect)(() => {
    displayOnlyBicycleHome.current = options.displayOnlyBicycleHome || false;
  }, [options.displayOnlyBicycleHome]);
  (0, _react.useEffect)(() => {
    const {
      selectedTripStep: step
    } = options;
    selectedTripStep.current = step;
    if (_poiAnnotationsMap && step) poiPopupRef.current?.update(_poiAnnotationsMap, step);
  }, [_poiAnnotationsMap, options.selectedTripStep]);
  function getCategoriesMap() {
    return categories.current?.reduce((res, {
      code,
      color,
      icon
    }) => {
      res[code] = {
        color,
        icon
      };
      return res;
    }, {}) || {};
  }
  function init() {
    if (!map || initialized.current) return;
    if (getGeoJSONSource()) {
      initialized.current = true;
      return;
    }
    addGeoJSONSource();
    addCircleLayer(poisLayerId, sourceId, {
      'circle-radius': 4,
      'circle-stroke-width': 2,
      'circle-stroke-opacity': 1,
      'circle-color': ['get', 'color'],
      'circle-stroke-color': '#fff'
    });
    map.on('mouseenter', poisLayerId, event => {
      if (event.defaultPrevented) return;
      event.originalEvent.preventDefault();
      event.preventDefault();
      map.getCanvas().style.cursor = 'pointer';
      const {
        point,
        features
      } = event;
      if (map.queryRenderedFeatures(point).find(({
        layer: {
          id: layerId
        }
      }) => [_routing.arrivalLayerId, _routing.wayPointsLayerId].indexOf(layerId) !== -1) || !features || !features[0]) return;
      const {
        id,
        geometry,
        properties
      } = features[0];
      if (selectedPoiIdRef.current === id) return;
      if (typeof id === 'number' && geometry.type === 'Point') {
        const {
          coordinates: [lng, lat]
        } = geometry;
        openTooltip(id, {
          lat,
          lng
        }, properties?.title || null, 7);
      }
    });
    map.on('mousemove', poisLayerId, event => {
      const {
        point,
        features
      } = event;
      if (map.queryRenderedFeatures(point).find(({
        layer: {
          id: layerId
        }
      }) => [_routing.arrivalLayerId, _routing.wayPointsLayerId].indexOf(layerId) !== -1) || !features || !categories.current || !features[0]) return;
      const {
        id
      } = features[0];
      const selectedPoi = poisRef.current.find(poi => poi.id === id);
      if (selectedPoi && selectedPoi !== hoveredPoi.current) {
        if (hoveredPoi.current) {
          markers.current[hoveredPoi.current.id]?.marker.remove();
        }
        hoveredPoi.current = selectedPoi;
        if (hoveredPoi.current) {
          addMarker(map.getZoom(), getCategoriesMap(), hoveredPoi.current, {
            forced: true
          });
        }
      }
    });
    map.on('mouseleave', poisLayerId, () => {
      if (map) map.getCanvas().style.cursor = '';
      clearTooltip();
    });
    map.on('click', poisLayerId, event => {
      if (event.originalEvent.defaultPrevented) return;
      event.originalEvent.preventDefault();
      const {
        features
      } = event;
      if (features && features.length > 0) {
        const {
          id: poiId,
          geometry,
          properties
        } = features[0];
        const zoom = properties?.asMarkerMinZoom;
        if (typeof poiId === 'number') {
          selectedPoiIdRef.current = poiId;
          selectPoi(poisRef.current.find(({
            id
          }) => id === poiId) || null);
        }
        if (zoom && geometry.type === 'Point') {
          const {
            coordinates: [lng, lat]
          } = geometry;
          map.flyTo({
            center: {
              lat,
              lng
            },
            zoom
          });
        }
      }
    });
    initialized.current = true;
  }
  function openPoiPopup(poi) {
    closePrevSelectedPoiPopup();
    if (smallDevice) return;
    const {
      location: {
        point: {
          coordinates: [lng, lat]
        }
      }
    } = poi;
    const selectedMarker = selectedPoiIdRef.current && markers.current[selectedPoiIdRef.current];
    if (!selectedMarker || !categories.current) {
      unselect();
      return;
    }
    if (selectedMarker.marker.getPopup().isOpen()) return;
    selectedMarker.marker.togglePopup();
    const ele = document.getElementById(`poi-${poi.id}-popup`);
    if (ele) {
      const container = (0, _client.createRoot)(ele);
      container.render(/*#__PURE__*/_react.default.createElement(_poiPopup.default, {
        categories: categories.current,
        enqueueSnackbar: options.enqueueSnackbar,
        onAddAsRideStep: options.onAddAsRideStep,
        onClose: () => {
          if (selectedMarker.marker.getPopup().isOpen()) selectedMarker.marker.togglePopup();
          if (container) container.unmount();
        },
        onPoiAddedToTripStep: options.onPoiAddedToTripStep,
        onPoiRemovedFromTripStep: options.onPoiRemovedFromTripStep,
        onRemoveFromRideSteps: options.onRemoveFromRideSteps,
        onSearchUpdated: options.onSearchUpdated,
        onTripStepAccomodationSelected: options.onTripStepAccomodationSelected,
        onTripStepAccomodationUnselected: options.onTripStepAccomodationUnselected,
        poi: poi,
        poiAnnotationsMap: poiAnnotationsMap.current,
        ref: poiPopupRef,
        search: options.search,
        selectedTripStep: selectedTripStep.current,
        theme: theme,
        widgetConfig: options.widgetConfig
      }));
    }
    setTimeout(() => centerPopup({
      lat,
      lng
    }, selectedMarker.marker.getPopup()), 100);
  }
  function closePrevSelectedPoiPopup() {
    Object.values(markers.current).forEach(({
      id,
      marker
    }) => {
      if (id !== selectedPoiIdRef.current && marker.getPopup().isOpen()) marker.togglePopup();
    });
  }
  function addMarker(zoom, categoriesMap, poi, {
    forced
  } = {}) {
    if (!map) return;
    const {
      id,
      title,
      source,
      location: {
        point: {
          coordinates: [lng, lat]
        }
      },
      categoryCodes
    } = poi;
    const categoryCode = forced ? categoryCodes[0] : categoryCodes.find(code => selectedCategories.current[code] && zoom >= (categoryAsMarkerMinZoom[code] || asMarkerMinZoom));
    function onClick() {
      const markerMinZoom = categoryCode && categoryAsMarkerMinZoom[categoryCode] || asMarkerMinZoom;
      clearTooltip();
      if (map && map.getZoom() < markerMinZoom) {
        const {
          coordinates: [lng, lat]
        } = poi.location.point;
        hoveredPoi.current = null;
        map.flyTo({
          center: {
            lat,
            lng
          },
          zoom: markerMinZoom
        });
      } else {
        if (selectedPoiIdRef.current !== id) {
          selectedPoiIdRef.current = id;
          closePrevSelectedPoiPopup();
          selectPoi(poi);
          openPoiPopup(poi);
        }
      }
    }
    function onMouseEnter() {
      openTooltip(id, {
        lat,
        lng
      }, title, 12);
    }
    function onMouseLeave() {
      if (hoveredPoi.current) {
        markers.current[hoveredPoi.current.id]?.marker.remove();
        hoveredPoi.current = null;
      }
      clearTooltip();
    }
    const {
      useNewImageMarkers
    } = options;
    const popup = new _maplibreGl.Popup({
      maxWidth: '350px',
      closeButton: false,
      closeOnClick: true,
      className: 'map-custom-popup',
      offset: useNewImageMarkers ? [0, -25] : 8
    }).setHTML(`<div id="poi-${id}-popup"></div>`);
    popup.on('close', () => {
      if (selectedPoiIdRef.current === id && markers.current[id]) {
        unselect();
      }
    });
    const marker = (useNewImageMarkers ? (0, _utils.createNewImageMarker)({
      color: categoryCode && categoriesMap[categoryCode]?.color || '#000',
      icon: categoryCode && categoriesMap[categoryCode]?.icon || '',
      height: 30
    }, {
      onClick,
      onMouseEnter,
      onMouseLeave
    }) : (0, _utils.createImageMarker)({
      radius: 10,
      borderWidth: 2,
      backgroundColor: categoryCode && categoriesMap[categoryCode]?.color || '#000',
      backgroundImage: categoryCode && categoriesMap[categoryCode]?.icon || '',
      backgroundSize: 14,
      zIndex: selectedPoiIdRef.current === id ? '2' : '1'
    }, {
      onClick,
      onMouseEnter,
      onMouseLeave
    })).setLngLat({
      lat,
      lng
    }).setPopup(popup).addTo(map);
    markers.current[id] = {
      id,
      source,
      marker
    };
  }
  function update(pois, {
    source: _source,
    forcedAsMarker,
    alwaysVisible
  } = {}) {
    const source = _source || 'geovelo';
    poisRef.current = pois;
    if (!map || !categories.current) return;
    const zoom = map.getZoom();
    const bounds = map.getBounds();
    const categoriesMap = getCategoriesMap();
    const filteredPois = pois.filter(({
      id,
      categoryCodes,
      bicycleHome,
      location: {
        point: {
          coordinates: [lng, lat]
        }
      },
      externalId,
      filterByBounds
    }) => forcedAsMarker?.find(_id => externalId ? _id === externalId : _id === id) || (!filterByBounds || bounds.contains({
      lat,
      lng
    })) && categoryCodes.find(code => selectedCategories.current[code]) && (!displayOnlyBicycleHome.current || bicycleHome));
    const count = filteredPois.length;
    const filteredPoisAsMarker = filteredPois.filter(({
      id,
      categoryCodes,
      externalId
    }) => forcedAsMarker?.find(_id => externalId ? _id === externalId : _id === id) || categoryCodes.find(code => zoom >= (categoryAsMarkerMinZoom[code] || asMarkerMinZoom)));
    const filteredPoisAsMarkerIds = filteredPoisAsMarker.reduce((res, {
      id
    }) => {
      res[id] = true;
      return res;
    }, {});

    // remove markers that are no longer visible
    Object.values(markers.current).filter(({
      id,
      source: poiSource
    }) => poiSource === source && !filteredPoisAsMarkerIds[id]).forEach(({
      id,
      marker
    }) => {
      marker.remove();
      delete markers.current[id];
    });

    // unselect poi if no longer visible
    if (selectedPoiIdRef.current && !markers.current[selectedPoiIdRef.current] && !alwaysVisible) {
      unselect();
    }

    // add markers that were not visible
    filteredPoisAsMarker.filter(({
      id
    }) => !markers.current[id]).forEach(poi => addMarker(zoom, categoriesMap, poi, {
      forced: !!forcedAsMarker?.find(id => poi.externalId ? id === poi.externalId : id === poi.id)
    }));

    // close previous selected poi popup
    closePrevSelectedPoiPopup();

    // open selected poi popup
    const selectedPoi = selectedPoiIdRef.current && pois.find(({
      id
    }) => selectedPoiIdRef.current === id);
    if (selectedPoi) openPoiPopup(selectedPoi);
    const filteredPoisAsPoints = filteredPois.filter(({
      id,
      categoryCodes
    }) => !filteredPoisAsMarkerIds[id] && (alwaysVisible || categoryCodes.find(code => zoom >= (categoryMinZoom[code] || minZoom))));
    const visibleCount = filteredPoisAsMarker.length + filteredPoisAsPoints.length;
    updateGeoJSONSource({
      type: 'FeatureCollection',
      features: filteredPoisAsPoints.map(poi => {
        const categoryCode = poi.categoryCodes.find(code => selectedCategories.current[code] && (alwaysVisible || zoom > (categoryMinZoom[code] || minZoom)));
        const category = categories.current?.find(({
          code
        }) => code === categoryCode);
        return {
          id: poi.id,
          type: 'Feature',
          geometry: poi.location.point,
          properties: {
            title: poi.title || (category?.labelKey ? t(category.labelKey, {
              context: 'one'
            }) : ''),
            asMarkerMinZoom: categoryCode && categoryAsMarkerMinZoom[categoryCode] || asMarkerMinZoom,
            color: categoryCode && categoriesMap[categoryCode]?.color || '#000'
          }
        };
      })
    });
    if (options.displayZoomInSnackbar) {
      options.closeSnackbar?.(snackbarKey.current || undefined);
      if (count > 0 && visibleCount < count) snackbarKey.current = options.enqueueSnackbar?.(t('commons.actions.zoom_in_to_display_pois', {
        count
      })) || null;
    }
  }
  function select(poi, {
    openPopup,
    disableAnimation
  } = {}) {
    if (!map) return;
    const {
      id,
      location: {
        point: {
          coordinates: [lng, lat]
        }
      },
      categoryCodes
    } = poi;
    const zoom = map.getZoom();
    const categoryCode = categoryCodes.find(code => selectedCategories.current[code] && zoom > (categoryMinZoom[code] || minZoom));
    selectedPoiIdRef.current = id;
    selectPoi(poi);
    if (openPopup) openPoiPopup(poi);else {
      if (!markers.current[id]) addMarker(zoom, getCategoriesMap(), poi, {
        forced: true
      });
      map.flyTo({
        center: {
          lat,
          lng
        },
        zoom: categoryCode && categoryAsMarkerMinZoom[categoryCode] || asMarkerMinZoom,
        animate: !disableAnimation
      });
    }
  }
  function unselect() {
    selectedPoiIdRef.current = null;
    selectPoi(null);
    closePrevSelectedPoiPopup();
  }
  function openTooltip(id, location, title, _offset = 0) {
    clearTooltip();
    if (!map || !title || selectedPoiIdRef.current === id) return;
    const {
      anchor,
      offset
    } = (0, _utils.getAnchorAndOffset)(map, location, _offset);
    poiTooltip.current = new _maplibreGl.Popup({
      anchor,
      offset: options.useNewImageMarkers && Array.isArray(offset) && [offset[0], -15] || 0,
      className: 'map-tooltip',
      closeButton: false
    }).setHTML(title).setLngLat(location).addTo(map);
  }
  function clearTooltip() {
    poiTooltip.current?.remove();
  }
  function clear() {
    poisRef.current = [];
    Object.values(markers.current).forEach(({
      marker
    }) => {
      marker.remove();
    });
    markers.current = {};
    unselect();
    clearTooltip();
    clearGeoJSONSource();
  }
  return {
    initialized: initialized.current,
    selectedPoi,
    init,
    update,
    select,
    unselect,
    clear
  };
}